import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import moment from "moment";

import {
  fetchRequestHistory,
  handleFileAvailableClick,
  fetchPageContent,
  fetchProfileAPI,
  checkIfMDNisSMSCapable,
  setBreadCrumbListInRedux
} from "../actions";
import {resendPasswordBegin} from "../actions/resendPassword"
import { setA11yContent } from "../../NavigationHelper/actions";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { media } from "utils/style";
import { checkAMLob } from "utils/checkAMLob";
import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";

import CommonHeader from "common-components/Header";
import Alert from "common-components/Alert";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { MaximumPasswordsReached } from "../../ResendPassword";
import { convertStringToElements } from "@vds/html-parsers";


import StyledLinkSmall from "common-components/StyledLinkSmall";


class RequestHistory extends Component {
  state = {
    showMaxPasswordModal: false,
    statusText: {}
  };

  componentDidMount() {
   
   
    if (!checkNestedObject(this.props.pageContent, "sections", [1], [4], "statusText", [0])) {
      let pageContentUrl = "";

      if (checkAMLob() === "ott") {
        pageContentUrl = ENDPOINTS.FETCH_OTT_LANDING_PAGE;
      } else if (checkAMLob() === "nico") {
        pageContentUrl = ENDPOINTS.FETCH_FAMILY_MONEY_LANDING_PAGE;
      } else if (checkAMLob() === "vzt") {
        pageContentUrl = ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE;
      } else if (checkAMLob() === "vils") {
        pageContentUrl = ENDPOINTS.FETCH_VILS_LANDING_PAGE;
      } else if (checkAMLob() === "autoapp") {
        pageContentUrl = ENDPOINTS.FETCH_CVA_LANDING_PAGE;
      } else if (checkAMLob() === "ip") {
        pageContentUrl = ENDPOINTS.FETCH_CVA_LANDING_PAGE;
      }
      else {
        pageContentUrl = ENDPOINTS.FETCH_WIRELESS_LANDING_PAGE;
      }
      this.props.fetchPageContent(pageContentUrl).then(() => {
        this.setPageContent();
      });
    } else {
      this.setPageContent();
    }
    
    this.props.fetchRequestHistory().then(() => {
      return this.props.elementsData.map(item => {
        if (item.mtnList.length > 2) {
          return this.setState({ [item.uniqueTxnId]: false });
        }
        return item;
      });
    });
  }
  componentWillUnmount(){
    if(this.el && this.handleClick) {
      this.el.removeEventListener('click',this.handleClick);

    }
  }
  componentDidUpdate(){
    const { history } = this.props;
    const el = document.querySelector('.vpd_aem_react_link');
    if (el) {
      this.el=el;
      this.handleClick= (e) => {
        e.preventDefault();
        const hrefValue = el.getAttribute('href');
          history.push({
            pathname: hrefValue,
          });
        }
        el.addEventListener('click',this.handleClick);
    }  
    }

  setPageContent = () => {
    
    
    const { pageContent } = this.props;
    if (checkNestedObject(pageContent, "sections", [1], [4], "statusText", [0])) {
      this.setState({ statusText: { ...pageContent.sections[1][4].statusText[0] } });
    }

    if (checkNestedObject(pageContent, "sections", [2], "gnavDropdown")) {
      this.props.setBreadCrumbListInRedux({ gnavDropdown: pageContent.sections[2].gnavDropdown });
    }

    if (checkNestedObject(pageContent, "sections", [2], "breadCrumbs")) {
      this.props.setBreadCrumbListInRedux({ breadCrumbs: pageContent.sections[2].breadCrumbs });
      this.props.setBreadcrumbList([
        { label: pageContent.sections[2].breadCrumbs.landingPage, path: "/privacy/secure/your-data" },
        { label: pageContent.sections[2].breadCrumbs.requestHistory, path: "/privacy/secure/request-history" }
      ]);
    }

    if (checkNestedObject(pageContent, "sections", [1], [4], "sc_pagetitle")) {
      this.props.setA11yContent("Your request history", pageContent.sections[1][4].sc_pagetitle);
    }
  };

  handleFileAvailableClick = item => {
    
    this.props.handleFileAvailableClick(item);
    this.props.history.push("/privacy/secure/download-status");
  };

  handleCorrectInprogressClick = item => {
    
    const { uniqueTxnId } = item;
    if (checkNestedObject(this.props.pageContent, "sections", [2], "correction")) {
      this.props.history.push({
        pathname: "/privacy/secure/correction-status",
        state: {
          confirmAuth: true,
          historyInfo: item
        }
      });
    }
  }

  handleAppealPendingClick = item => {
    
    const { uniqueTxnId } = item;

    const theActualRecordOnWhichTheAppealApplied = this.props.elementsData.filter((item) => item.appealId && item.appealId.endsWith(uniqueTxnId) && item.status === "APPEAL_PENDING");

    if (checkNestedObject(this.props.pageContent, "sections", [2], "appeal", [2])) {
      this.props.history.push({
        pathname: "/privacy/secure/appeal-status",
        state: {
          confirmAuth: true,
          historyInfo: item,
          theActualRecordOnWhichTheAppealApplied
        }
      });
    }
  }

  renderRequestType = type => {
    
    const { statusText } = this.state;

    if (type === "DOWNLOAD" || type === "DOWNLOAD_AFFIDAVIT") {
      return statusText.download;
    } else if (type === "DELETE") {
      return statusText.deletion;
    } else if (type.toLowerCase() === "agent authorization") {
      return statusText.agentAuthorization;
    } else if (type === "APPEAL") {
      return statusText.appeal;
    } else if (type === "CORRECT") {
      return statusText.correct;
    }

    return type;
  };

  checkPasswordFlow = () => {
    if (parseInt(this.props.noOfPwdNotificationRemaining) === 0) {
      return this.setState({ showMaxPasswordModal: true });
    }
    this.props.resendPasswordBegin("request-history");
  };

  resendPasswordClick = historyInfo => {
    
    this.props.handleFileAvailableClick(historyInfo);

    if (!checkNestedObject(this.props, "resend_password_page")) {
      let url = "";

      if (checkAMLob() === "vzt") {
        url = ENDPOINTS.FETCH_WIRELINE_STATUS_PAGES;
      } else if (checkAMLob() === "ott") {
        url = ENDPOINTS.FETCH_OTT_STATUS_PAGES;  
      } 
       else {
        url = ENDPOINTS.FETCH_DOWNLOAD_STATUS_PAGES;
      }

      this.props.fetchPageContent(url).then(() => {
        if (!this.props.error) {
          this.checkPasswordFlow();
        }
      });
    } else {
      this.checkPasswordFlow();
    }
  };

  renderStatusColumn = ({ requestType, status, requestedBy, downloadAvailabilityDeadline, ...rest }) => {
    
    let statusText = "";
    const historyInfo = {
      requestType,
      status,
      downloadAvailabilityDeadline,
      ...rest
    };
    const { statusText: displayText } = this.state;


    if (requestType === "DOWNLOAD" || requestType === "DOWNLOAD_AFFIDAVIT") {
      if (status === "COMPLETED") {
        const { appealId } = historyInfo;

        const isBefore = moment().isBefore(moment(downloadAvailabilityDeadline).add(1, "d"));
        const isAfter = moment().isAfter(moment(downloadAvailabilityDeadline).add(1, "d"));

        if (isBefore) {
          statusText = (
            <>
              <StyledButton
                role="link"
                onClick={() => this.handleFileAvailableClick({ ...historyInfo, downloadReady: true })}
              >
                {displayText.fileAvailable}
              </StyledButton>
              {/* <StyledButton
                onClick={() => this.resendPasswordClick(historyInfo)}
                style={{ display: "block", textAlign: "left" }}
              >
                {displayText.resendPassword}
              </StyledButton> */}
            </>
          );
        } else if (isAfter) {
          statusText = "FILE_EXPIRED";
          if (appealId) {
            statusText = (
              <>
                <div style={{ maxWidth: "128px" }}>{displayText.appealFileExpired}</div>
              </>
            );
          }
        }
      } else if (status === "IN_PROGRESS" || status === "REQUEST_PENDING") {
        statusText = (
          <StyledButton
            role="link"
            onClick={() => this.handleFileAvailableClick({ ...historyInfo, downloadReady: false })}
          >
            {status === "IN_PROGRESS" ? displayText.inProgress : displayText.requestPending}
          </StyledButton>
        );
      } else {
        statusText = status;
      }
    }
    else if (requestType === "APPEAL") {
      if (status === "PENDING") {
        statusText = (
          <StyledButton
            role="link"
            onClick={() => this.handleAppealPendingClick({ ...historyInfo })}
          >
            {status === "PENDING" ? displayText.pending : status}
          </StyledButton>
        );

      }
      else {
        statusText = status;
      }
    }
    else if (requestType === "CORRECT") {
      if (status === "IN_PROGRESS") {
        if (requestedBy === "Agent") {
          statusText = status;
        } else {
          statusText = (
            <StyledButton
              role="link"
              onClick={() => this.handleCorrectInprogressClick({ ...historyInfo })}
            >
              {status === "IN_PROGRESS" ? displayText.inProgress : status}
            </StyledButton>
          );
        }
      }
      else {
        statusText = status;
      }
    }
    else {
      statusText = status;
    }
    return this.transformStatusText(statusText);
  };

  /* added for APPEAL */
  isEligibleForAppeal = ({ status, appealFlag }) => {
    //for now checking against the status.
    //once the flag is ready i will use the same.
    const { cpraFlagEnabled } = window.reactGlobals;
    return ("DENIED" === status && "Y" === appealFlag && (undefined !== cpraFlagEnabled && "Y" === cpraFlagEnabled));
  }

  renderAppealColumn = (item, amLob) => {
    const history_details = this.props.pageContent.sections[1][4];
    const { buttons } = history_details;
    const { uniqueTxnId, requestType, state } = item;
    let appealContent = "";
    let appealConfirmationContent = "";
    if (amLob === "vzw" || amLob === "vzt" ) {
      appealContent = this.props.pageContent.sections[2]["appeal"][0];
      appealConfirmationContent = this.props.pageContent.sections[2]["appeal"][1];
    }


    const isAnyDownloadInProgress = this.props.elementsData.filter((item) => item.requestType === "DOWNLOAD" && item.status === "IN_PROGRESS").length > 0;


    return (
      <StyledLinkSmall
        key={uniqueTxnId}
        background={buttons[0].type}
        disabledStatus={isAnyDownloadInProgress ? "disabled" : ""}
        to={{
          pathname: "/privacy/secure/submit-appeal",
          state: {
            confirmAuth: true,
            payload: { uniqueTxnId, requestType, state },
            appealContent,
            appealConfirmationContent
          }
        }}
      >
       
      {buttons[0].text}
      </StyledLinkSmall>
    );

  }
  /* end of added for APPEAL */

  renderMdnColumn = item => {
    if (item.mtnList.length > 2) {
      return Object.keys(this.state).map(key => {
        if (key === item.uniqueTxnId) {
          return item.mtnList.map((mdn, i) => {
            // This flag states if mdnList is expanded or not
            if (!this.state[item.uniqueTxnId]) {
              // If expanded flag is false this code runs
              if (i < 2) {
                return <li key={mdn}>{formatPhoneNumber(mdn)}</li>;
              }
            } else {
              return <li key={mdn}>{formatPhoneNumber(mdn)}</li>;
            }
            return null;
          });
        }
        return null;
      });
    } else {
      return item.mtnList.map(mdn => {
        return <li key={mdn}>{formatPhoneNumber(mdn)}</li>;
      });
    }
  };
  
  renderTableContent = (historyArray, fullNameForWln) => {
   
 
   
    const { statusText } = this.state;

    return historyArray.map(item => {

      const formattedDate = moment(cleanDateFormat(item.dateOfRequest), "YYYY-MM-DD HH:mm:ss").format(
        "MMM D, YYYY h:mma"
      );
      const amLob = checkAMLob();

      return (
        <TR key={item.uniqueTxnId}>
          <TD>
            <StatusSpan>{formattedDate}</StatusSpan>
          </TD>
          <TD>
            <StatusSpan>{this.renderRequestType(item.requestType)}</StatusSpan>
          </TD>
          <TD>{this.renderStatusColumn(item)}</TD>
          {/* DPCMP - 156,155,163 Request Number column */}

          {window.reactGlobals.requestNumberFFlag ?
          <TD>{item.requestNumber}</TD>
          : ""
          }
          {amLob === "vzt" && (
            <TD data-qm-encrypt="true" >
              {item.agentRegId ? statusText.agent : fullNameForWln || formatPhoneNumber(item.loggedInMtn)}
            </TD>
          )}

          {amLob !== "ott" && amLob !== "vzt" && amLob !== "nico" && amLob !== "vils" &&  amLob !== "autoapp" && amLob !== "ip" && (
            <Fragment>
              <TD data-qm-encrypt="true" >{item.agentRegId ? statusText.agent : formatPhoneNumber(item.loggedInMtn)}</TD>
              <TD data-qm-encrypt="true">
              

                <ul id={item.uniqueTxnId}>{this.renderMdnColumn(item)}</ul>
                {item.mtnList.length > 2 && (
                  
                  <StyledButton
                    aria-controls={item.uniqueTxnId}
                    aria-expanded={this.state[item.uniqueTxnId]}
                    style={{ marginTop: "10px", display: "block" }}
                    onClick={() =>
                      this.setState({
                        [item.uniqueTxnId]: !this.state[item.uniqueTxnId]
                      })
                    }
                  >
                    {this.state[item.uniqueTxnId] ? statusText.showLess : statusText.showMore}
                  </StyledButton>
                )}
              </TD>
            </Fragment>
          )}
          {amLob !== "ott" && amLob !== "nico" && amLob !== "vils" && (
            <Fragment>
              {/* added for APPEAL */}
              {
                true === this.isEligibleForAppeal(item)
                  ?
                  <TD>{!this.props.loading && item ? this.renderAppealColumn(item, amLob) : ""}</TD>
                  :
                  ""
              }
              {/* end of added for APPEAL */}
            </Fragment>
          )}

        </TR>
      );
    });
  };

  transformStatusText = status => {

    const cleanStr = typeof status === "string" ? status.toUpperCase() : status;
    const { statusText } = this.state;

    switch (cleanStr) {
      case "REMOVED":
        return statusText.removed;
      case "APPROVED":
        return statusText.approved;
      case "FILE_EXPIRED":
        return statusText.fileExpired;
      case "FILE_AVAILABLE":
        return statusText.fileAvailable;
      case "REQUEST_PENDING":
        return statusText.requestPending;
      case "EXPIRED":
        return statusText.expired;
      case "IN_PROGRESS":
        return statusText.inProgress;
      case "COMPLETED":
        return statusText.completed;
      case "CANCELLED":
        return statusText.cancelled;
      case "CANCEL_COMPLETE":
        return statusText.cancelled;
      case "PENDING_PROCESS":
        return statusText.pendingProcess;
      case "PARTIALLY_COMPLETED":
        return statusText.partiallyCompleted;
      case "REJECTED":
        return statusText.rejected;
      case "DELETED":
        return statusText.deleted;
      case "NOT APPROVED":
        return statusText.notApproved;
      case "DENIED":
        return statusText.denied;
      case "APPEAL_DENIED":
        return statusText.appealDenied;
      case "APPEAL_COMPLETED":
        return statusText.appealComplete;
      case "APPEAL_PENDING":
        return statusText.appealPending;
      case "APPEAL_CANCELLED":
        return statusText.cancelled;
      case "PENDING":
        return statusText.pendingApproval;
      default:
        return status;
    }
  };


  render() {

    if (!checkNestedObject(this.props.pageContent, "sections", [1], [3])) {
      return <RectangleLoader style={{ padding: "0 16px" }} />;
    }
   
    const { amLob } = window.reactGlobals;
    const no_history = this.props.pageContent.sections[1][3];
    const history_details = this.props.pageContent.sections[1][4];
    const { appeal_proof } = this.props.pageContent.sections[2];

    
    let privacyInquiryInfo;

    if(amLob === 'vzw' || 'vzt'){
     
       privacyInquiryInfo = appeal_proof && appeal_proof[0]["Category"] && appeal_proof[0]["Category"].length > 0 ? appeal_proof[0]["Category"][0].category_description : "";
    }else if (amLob === 'autoapp' || 'ip'){
       privacyInquiryInfo = appeal_proof && appeal_proof[0]["Category"] && appeal_proof[0]["Category"].length > 0 ? appeal_proof[0]["Category"][0].category_description : "";
    }else {
       privacyInquiryInfo = appeal_proof && appeal_proof["Category"] && appeal_proof["Category"].length > 0 ? appeal_proof["Category"][0].category_description : "";
    }

  {/* DPCMP - 156,155,163 Request Number column */}

    if ((amLob === "ott" || amLob === "nico" || amLob === "vils" || amLob === "autoapp" || amLob === "ip") && !window.reactGlobals.requestNumberFFlag) {
      history_details.genericList[0].list = history_details.genericList[0].list.filter(
        item => item.jsonKey !== "requestnumberheading"
        )
    }
    {/* DPCMP - 156,155,163 Request Number column */}

    if (amLob === "vzt") {
      window.reactGlobals.requestNumberFFlag ?
        history_details.genericList[0].list = history_details.genericList[0].list.filter(
        item => item.jsonKey !== "ForLineHeading"
        )
      :
      history_details.genericList[0].list = history_details.genericList[0].list.filter(
        item => item.jsonKey !== "ForLineHeading" && item.jsonKey != "requestnumberheading"
        )
    }
    {/* DPCMP - 156,155,163 Request Number column */}

    if (amLob === "vzw" && !window.reactGlobals.requestNumberFFlag) {
      history_details.genericList[0].list = history_details.genericList[0].list.filter(
      item => item.jsonKey !== "requestnumberheading"
      )
    }

    // if (amLob === "autoapp") {
    //   history_details.genericList[0].list = history_details.genericList[0].list.filter(
    //     item => item.jsonKey !== "RequestedByHeading" && item.jsonKey !== "ForLineHeading"
    //   );}
    // if (amLob === "ip") {
    //     history_details.genericList[0].list = history_details.genericList[0].list.filter(
    //       item => item.jsonKey !== "RequestedByHeading" && item.jsonKey !== "ForLineHeading"
    //   );}

    return (
      <Container noTabletPadding>
        {this.props.loading ? (
          <RectangleLoader
            style={{
              position: "absolute",
              padding: "0px 16px",
              top: "0",
              left: "0",
              bottom: "0",
              right: "0",
              background: "#fff",
              animation: "0",
              margin: "0"
            }}
          />
        ) : null}
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
        {this.state.showMaxPasswordModal ? (
          <MaximumPasswordsReached
            modalContent={this.props.modalContent}
            closeModal={() => this.setState({ showMaxPasswordModal: false })}
            historyLinkClick={() => this.setState({ showMaxPasswordModal: false })}
          />
        ) : null}
        <Div>
          <Header>{history_details.section_title}</Header>
          {this.props.elementsData && this.props.elementsData.length ? (
            <Table>
              <thead>
                <TR>
                  {history_details.genericList[0].list.map(item => (
                    <TH key={item.jsonKey}>
                      <Span>{item.jsonValue}</Span>
                    </TH>
                  ))}
                </TR>
              </thead>
              <tbody>{this.renderTableContent(this.props.elementsData, this.props.fullNameForWln)}</tbody>
            </Table>

          ) : (
            <P>{no_history.genericList[0].list[0].jsonValue}</P>
          )}

          {window.reactGlobals.cpraFlagEnabled && "Y" === window.reactGlobals.cpraFlagEnabled && (
            <PrivacyInquiry>{convertStringToElements(privacyInquiryInfo)}</PrivacyInquiry>
          )}

        </Div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  requestHistory: { elementsData, fullNameForWln },
  loadingAndErrorState: { loading, error },
  profileInformation: deviceList,
  downloadAndDelete: { noOfPwdNotificationRemaining },
  pageContent: {
    maximum_passwords_reached: modalContent,
    resend_password: resend_password_page,
    ...pageContent
  }
}) => ({
  elementsData,
  fullNameForWln,
  loading,
  error,
  deviceList,
  noOfPwdNotificationRemaining,
  modalContent,
  resend_password_page,
  pageContent
});

RequestHistory.propTypes = {
  requestHistory: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default connect(
  mapStateToProps,
  {
    fetchRequestHistory,
    setA11yContent,
    handleFileAvailableClick,
    setBreadcrumbList,
    fetchPageContent,
    fetchProfileAPI,
    checkIfMDNisSMSCapable,
    resendPasswordBegin,
    setBreadCrumbListInRedux
  }
)(RequestHistory);

const Header = styled(CommonHeader)`
  margin-bottom: 80px;

  ${media.mobile`
    margin-bottom: 40px;
  `}
`;

const StatusSpan = styled.span`
  ${media.tablet`
    max-width: 100px;
    display: inline-table;
  `}

  ${media.mobile`
    max-width: 100px;
    display: inline-table;
  `}
`;

const Div = styled.div`
  max-width: 809px;
  overflow: auto;

  ${media.tablet`
    margin: 0 auto;
  `}
`;

const Span = styled.span`
  display: block;

  ${media.mobile`
    max-width: 73px;
  `}
`;

const Table = styled.table`
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  border-top: 4px solid #000;

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
  `}
`;

const P = styled.p`
  padding: 20px 0;
  border-bottom: 1px solid;
  border-top: 4px solid #000;
`;

const PrivacyInquiry = styled.div`
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size:12px;
  padding-top: 40px;
  max-width:415px;


  a,p {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
  }


`;

const StyledButton = styled.button`
  cursor: pointer;
  background: none;
  border: 0;
  font-size: 14px;
  text-decoration: underline;
  padding: 2px;
  margin: 0 -2px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;

  ${media.mobile`
    font-size: 12px;
  `}
`;

const TR = styled.tr`
  border-bottom: 1px solid;
`;

const TH = styled.th`
  text-align: left;
  padding: 19px 0px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  min-width: 105px;

  ${media.tablet`
    min-width: 130px;  
  `}

  ${media.mobile`
    padding: 14px 0;
    min-width: 90px;
  `}
`;

const TD = styled.td`
  padding: 24px 0px;

  ${media.mobile`
    padding: 20px 0px;    
  `}
`;
